import { useCallback, useEffect } from "react";
import isEqual from "react-fast-compare";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { FulfilledUpdateMethod, RequestState, REQUEST_STATE } from "../../dataTypes";
import { ControlPointsFilter } from "../dataTypes";
import { fetchControlPoints } from "../reducers/fetchControlPoints";
import { selectRequestState } from "../controlPointSelectors";
import { useValidateUserIsLoggedIn } from "../../utils/useValidateUserIsLoggedIn";
import { setError } from "../../dialog/dialogSlice";

let filterRef: ControlPointsFilter | undefined;
let requestStateRef: RequestState | undefined;

const useFetchControlPoints = () => {
  const dispatch = useAppDispatch();
  const result = useValidateUserIsLoggedIn();

  const requestState = useAppSelector(selectRequestState);

  if (requestStateRef === undefined) requestStateRef = requestState;

  useEffect(() => {
    requestStateRef = requestState;
  }, [requestState]);

  const loadControlPoints = useCallback(
    async ({
      filter,
      fulfilledUpdateMethod,
    }: {
      filter?: ControlPointsFilter;
      fulfilledUpdateMethod?: FulfilledUpdateMethod;
    }) => {
      if (result.isError) {
        dispatch(setError({ value: result.errorMessage }));
      } else {
        if (!isEqual(filter, filterRef) || requestStateRef !== REQUEST_STATE.PENDING) {
          requestStateRef = REQUEST_STATE.PENDING;
          filterRef = filter ? { ...filter } : undefined;

          const { payload } = await dispatch(fetchControlPoints({ filter, fulfilledUpdateMethod }));

          if (payload && "page" in payload) {
            return payload.page.map(({ id }) => id);
          }
        }
      }
    },
    [dispatch, result],
  );

  return loadControlPoints;
};

export default useFetchControlPoints;
